import React from "react";
import { Link } from "react-router-dom";
import Search from "./Search";

const SearchArticle = () => {
    const search = {
        banner:{
            heading:"How can we help?",
        },
        question:{
            title:"What ownership information is provided on each property?",
            pera:"<p>The Owner tab is comprised owners and contacts collected from public sources as well as data from our exclusive data partners. We have been able to pierce through shell LLCs and identify true owners to ensure you are granted the most accurate access to property ownership details.</p><p>You will see two sections on the owner tab -- Owners and Contacts. The Owner section includes the company and/or people owners that we have identified as being the owner of the property. Here, if applicable, you will be able to see if a property is owned directly or through a subsidiary, branch or shell company. We have also been able to identify and indicate if an owner is affiliated with a religious or government entity.</p><p>The Contacts section includes names, job titles, addresses, phone numbers and/or emails for individuals that are associated with the identified company owner.</p><p>We always include the Reported Owner information on this tab which is details derived from the tax assessor record as well as Mortgage Signatory information.</p><p>To learn more about everything the owner tab has to offer, check out the article, Get the most out of the new owner tab!</p>",
            dp:"DR",
            auth_name:"Diana Richards",
            time:"Updated a over a week ago",
        }
    }
  return (
    <>
      <Search data={search.banner}/>
      <section className="ans_blk">
        <div className="contain">
            <div className="main_title">
                <p>Search results for: <span>what is property?</span></p>
            </div>
            <ul className="ques_lst detail_article_help">
                <li>
                    <h5>{search.question.title}</h5>
                    <div className="br"></div>
                    <div className="auther_lbl">
                        <div className="auther_icon">
                            <span>{search.question.dp}</span>
                        </div>
                        <div className="auther_cntnt">
                            <h6>Written by <span>{search.question.auth_name}</span></h6>
                            <p>{search.question.time}</p>
                        </div>
                    </div>
                    <div className="br"></div>
                    <p dangerouslySetInnerHTML={ {__html: search.question.pera} }></p>
                    <div className="review_blk text-center">
                        <h4>Did this answer your question?</h4>
                        <div className="btn_blk">
                            <button type="button"><img src="/images/excelent.svg" alt="" /></button>
                            <button type="button"><img src="/images/angry.svg" alt="" /></button>
                            <button type="button"><img src="/images/sad.svg" alt="" /></button>
                            <button type="button"><img src="/images/good.svg" alt="" /></button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
      </section>
    </>
  );
};

export default SearchArticle;
